import React, { Component } from "react";

class Counter extends Component {
  constructor(props) {
    super(props)
    var ws = new WebSocket("ws://www.msgb.us:29292/" + props.channel);
    
    ws.onopen = function() {
      
      // Web Socket is connected, send data using send()
      // ws.send("Message to send");
      // alert("Message is sent...");
    };
    const that = this;
    ws.onmessage = function (evt) { 
      var received_msg = evt.data;
      that.setState({msg : received_msg});
    };
    
    ws.onclose = function() { 
      
      // websocket is closed.
      console.log("Connection is closed..." + that.props.counter.id);
      that.setState({msg : "connection closed. subscribe again!"})
    };
    this.state = {ws:ws, msg: "connecting...", channel:props.channel};
  }

  handleChange(event) {
    this.setState({title: event.target.value})
  }

  handleSend(msg) {
    this.state.ws.send(msg);
    this.setState({title:''})
  }

  render() {

    let set = <div className="col-md-3"></div>;
    if(!this.props.readOnly) {
      set =  <div className="col-md-3"><form onSubmit={e => {e.preventDefault();this.handleSend(this.state.title)}}>
      <label >Send Message:</label>
      <input type='text' name='title' 
      value = {this.state.title}
onChange={this.handleChange.bind(this)} style={{ fontSize: 24 }}  />           
          <button type='submit'
      className="btn btn-secondary"
      
    >
      <i className="fa fa-send" aria-hidden="true" />
    </button>
    </form>
    </div>

    }

    return (
      <div>
        <div className="row">          
          <div className="col-md-2">
            <span style={{ fontSize: 24 }} className={"rj " + this.getBadgeClasses()}>
              {this.state.channel}
            </span>
          </div>
          <div className="col-md-1">
            <button
              className="btn btn-danger"
              onClick={() => {this.state.ws.close();this.props.onDelete(this.props.counter.id)}}
            >
              <i className="fa fa-trash-o" aria-hidden="true" />
            </button>
          </div>
          {set}
          <div className="col-md-2">
            <span style={{ fontSize: 24 }} className={this.getBadgeClasses()}>
              {this.state.msg}
            </span>
          </div>

        </div>
      </div>
    );
  }

  getBadgeClasses = () => {
    let classes = "badge m-2 badge-warning";
    // classes += this.props.counter.value === 0 ? "warning" : "primary";
    return classes;
  };

  formatCount = () => {
    const { value } = this.props.counter;
    return value === 0 ? "Zero" : value;
  };
}

export default Counter;
